import image1 from "../images/dentist.jpeg"
import image2 from "../images/dietician.jpg"
import image3 from "../images/gynecologist.jpg"
const list=[
    {
        image:image1,
        Category:"Dentist",
        name:"Dentist",
        description:"Teething trouble? Schedule a dental checkup"
    },
    {
        image:image3,
        Category:"Gynecologist ",
        name:"Gynecologist/Obstetrician",
        description:"Explore for women's health,pregnancy and infertility treatments"
    },
    {
        image:image2,
        Category:"Dietitian",
        name:"Dietitian/Nutrition",
        description:"Get guidance on eating right,weight management and sports nutrition"
    }
]

export default list